 import FakeCard from "./Components/FakeCard";
import React from "react";
import {editorNodeTypeEnum,
    fileTypeEnum,
    languageEnum, procedureNodeTypeEnum,
    procedureTypeEnum, fontsEnum, trainingAndFieldRoleEnum, contentCreatingRoleEnum
} from "./serverClientShared/sharedEnums";
import DisplayVideo from "./Components/RunProcedure/ProcedureMain/ProcedureMedia/DisplayVideo";
import DisplayPdf from "./Components/RunProcedure/ProcedureMain/ProcedureMedia/DisplayPdf";
import DisplayDocx from "./Components/RunProcedure/ProcedureMain/ProcedureMedia/DisplayDocx";
import {Paper, Tooltip, Popover} from "@mui/material";
import logo from "./assets/img/logo_1024_blue.png";
import CompassIcon from "./assets/svg-icons/CompassIcon";
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import * as sharedUtils from "./serverClientShared/sharedUtils";
import {strToCapital} from "./serverClientShared/sharedUtils";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import Cookies from "js-cookie";
import {Button} from "@mui/material";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {routes} from "./App";
import {getDocument} from "pdfjs-dist/webpack";
import {Video} from "video-metadata-thumbnails";
import Compressor from "compressorjs";
import {GeneralStore} from "./MobxStores/GeneralStore";
import {GeneralRequester} from "./MobxStores/RequestApi/GeneralRequester";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import TimelineIcon from "@mui/icons-material/Timeline";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import FallbackImage from './assets/img/image.png';
import FallbackMovie from './assets/img/movie.png';
import FallbackPdf from './assets/img/picture-as-pdf.png';
import androidIcon from './assets/img/android.png';
import holoLensIcon from './assets/img/holoLens.png';
import iosIcon from './assets/img/ios.png';
import macIcon from './assets/img/mac.png';
import webglIcon from './assets/img/webgl.png';
import windowsIcon from './assets/img/windows.png';
import {ThreeDIcon} from "./assets/svg-icons/ThreeDIcon";
import {sortTypeEnum} from "./enums";
import {isAndroid, isIOS, isMobile, isWindows, isTablet, isBrowser} from "react-device-detect";
import Settings from "./settings.json";
import MenuItem from "@mui/material/MenuItem";
import {generalStore, modalStore, procedureStore} from "./index";
import {toJS} from "mobx";
import FileSaver from 'file-saver';
import br from './assets/flags/4x3/br.svg';
import de from './assets/flags/4x3/de.svg';
import es from './assets/flags/4x3/es.svg';
import fr from './assets/flags/4x3/fr.svg';
import gb from './assets/flags/4x3/gb.svg';
import it from './assets/flags/4x3/it.svg';
import mx from './assets/flags/4x3/mx.svg';
import pt from './assets/flags/4x3/pt.svg';
import cn from './assets/flags/4x3/cn.svg';
import hk from './assets/flags/4x3/hk.svg';
import jp from './assets/flags/4x3/jp.svg';
import kr from './assets/flags/4x3/kr.svg';
import ru from './assets/flags/4x3/ru.svg';
import us from './assets/flags/4x3/us.svg';
import id from './assets/flags/4x3/id.svg';
import pl from './assets/flags/4x3/pl.svg';
import nl from './assets/flags/4x3/nl.svg';
import TheatersIcon from "@mui/icons-material/Theaters";
import WeekendIcon from "@mui/icons-material/Weekend";
import PersonIcon from "@mui/icons-material/Person";
import LinkIcon from "@mui/icons-material/Link";
import {SitePrepIcon} from "./assets/svg-icons/SitePrepIcon";
import ConditionalComponent from "./Components/Shared/ConditionalComponent";
import {FrontlineCheckbox} from "./Components/Shared/FrontlineCheckbox";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
 import ResizableImage from "./Components/RunProcedure/ProcedureMain/ProcedureMedia/DisplayImage";



export const getCountryFlag = code => {
    switch (code.toLowerCase()) {
        case "br":
            return br;
        case "de":
            return de;
        case "es":
            return es;
        case "fr":
            return fr;
        case "gb":
            return gb;
        case "it":
            return it;
        case "mx":
            return mx;
        case "pt":
            return pt;
        case "us":
            return us;
        case "cn":
            return cn;
        case "hk":
            return hk;
        case "jp":
            return jp;
        case "kr":
            return kr;
        case "ru":
            return ru;
        default:
            return
    }
}

export const getCountryFlagForRS = code => {
    switch (code) {
        case "br":
            return br;
        case "de-DE":
            return de;
        case "es-ES":
            return es;
        case "es-MX":
            return es
        case "en-GB":
            return us
        case "fr-FR":
            return fr;
        case "gb":
            return gb;
        case "it-IT":
            return it;
        case "mx":
            return mx;
        case "pt-PT":
            return pt;
        case "pt-BR":
            return pt
        case "en-US":
            return us;
        case "zh-CN":
            return cn;
        case "zh-HK":
            return cn
        case "hk":
            return hk;
        case "ja-JP":
            return jp;
        case "ko-KR":
            return kr;
        case "ru-RU":
            return ru;
        case "id-ID":
            return id;
        case "pl-PL":
            return pl;
        case "nl-NL":
            return nl;
        default:
            return
    } 
}

const getAltLangName = key => {
    switch (key) {
        case "GB":
            return "UK"
        case "CN":      //CN = Chinese flag, language = Mandarin (Simplified)
            return "Simp"
        case "HK":      //HK = Hong Kong flag, language = Cantonese (Traditional)
            return "Trad"
        default:
            return key
    }
}

const handleMoreClick = (event, openPopover, setOpenPopover, langKey, anchorElMorePopover, setAnchorElMorePopover) => {
    setAnchorElMorePopover({
        ...anchorElMorePopover,
        [langKey]: event.currentTarget,
    });
    let copyOpenPopover = {...openPopover};
    copyOpenPopover[langKey] = !copyOpenPopover[langKey];
    setOpenPopover(copyOpenPopover);
}

export const UPLOAD_CHUNK_SIZE = 1024 * 1024;
export const UPLOAD_CHUNK_SIZE_AWS = 1024 * 1024 * 6; // 6MB
export const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

async function importWorkbookAsync() {
    return new Promise(resolve => {
        import('exceljs').then(({Workbook}) => resolve(Workbook));
    })
}

export default class Utility {
    static ACCEPTED_IMAGE_TYPES = ["image/png", "image/jpeg"];

    static replaceFaviconsAndTitle(folderName, titleName) {
        const link16 = document.querySelector("link[rel~='icon'][sizes='16x16']");
        const link32 = document.querySelector("link[rel~='icon'][sizes='32x32']");
        const manifest = document.querySelector("link[rel~='manifest']");
        const appleIcon = document.querySelector("link[rel~='apple-touch-icon']");
        const title = document.querySelector("title");

        link16.href = link16.href.replace('dev/', '/').replace('favicons', `favicons/${folderName}`);
        link32.href = link32.href.replace('dev/', '/').replace('favicons', `favicons/${folderName}`);
        manifest.href = manifest.href.replace('dev/', '/').replace('favicons', `favicons/${folderName}`);
        appleIcon.href = appleIcon.href.replace('dev/', '/').replace('favicons', `favicons/${folderName}`);
        title.innerHTML = titleName;
    }

    static applyWhiteLabelBranding(whiteLabel) {
        if (!whiteLabel) return;
        if (whiteLabel.FaviconUrl) {
            document.querySelectorAll("link[rel~='icon'], link[rel~='apple-touch-icon']").forEach(link => {
                link.href = whiteLabel.FaviconUrl;
            });
        }
        if (whiteLabel.Name) {
            document.title = whiteLabel.Name;
        }
    }

    static getPlayerStyle(isBackgroundColor, backgroundColorRight, backgroundColorLeft, backgroundImageAddress) {
        return isBackgroundColor ? {
            background: `linear-gradient(259.25deg, ${backgroundColorRight} 12.76%, ${backgroundColorLeft} 86.63%)`
        } : {
            backgroundImage: `url(${backgroundImageAddress})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
        };
    }


    static getPushNotificationPermission() {
        if (!("Notification" in window)) {
            alert("This browser does not support desktop notifications");
        } else if (Notification.permission !== 'denied') {
            Notification.requestPermission().then();
        }
    }

    static checkPushNotificationPermission() {
        if (!("Notification" in window)) {
            alert("This browser does not support desktop notifications");
        } else if (Notification.permission !== 'granted') {
            Notification.requestPermission().then();
        }
    }

    static isTablet() {
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const isAndroidTablet = window.navigator.userAgent.includes('Android') && (screenWidth >= 600 || screenHeight >= 600);

        return isTablet ||
            (!isMobile && window.navigator.userAgent.includes('SamsungBrowser')) ||
            isAndroidTablet;
    }

    static isNotMobileDesktopSiteOn() {
        return window.innerWidth <= 1024;
    }

    static isTouchDevice() {
        return isTablet || isMobile
    }

    static isMobile() {
        return !isTablet && (isMobile || window.navigator.userAgent.includes('SamsungBrowser'));
    }

    static isAndroid() {
        return isAndroid || window.navigator.userAgent.includes('SamsungBrowser');
    }

    static  isPcBrowser(){
        return isBrowser && !(Utility.isMobile() || Utility.isTablet());
    }

    static arrayMove(array, oldIndex, newIndex) {
        const movedElement = array[oldIndex];
        if (!movedElement) {
            return array;
        }

        const newArray = [];
        array.forEach((elem, i) => {
            if (i === oldIndex) return;
            newArray.push(elem);

        });

        newArray.splice(newIndex, 0, movedElement);
        return newArray;
    }

    static deepClone(obj) { // TODO
        obj = toJS(obj);
        if (obj instanceof Set) {
            const tempOldArr = Array.from(obj);
            const tempNewArr = [];
            for (let i in tempOldArr) {
                tempNewArr[i] = Utility.deepClone(tempOldArr[i]);
            }
            return new Set(tempNewArr);
        }
        if (obj instanceof Map) {
            const tempOldArr = Array.from(obj.entries());
            const tempNewArr = [];
            for (let [key, value] of tempOldArr) {
                tempNewArr.push([
                    key,
                    Utility.deepClone(value)
                ])
            }
            return new Map(tempNewArr);
        }
        if (Array.isArray(obj)) {
            const tempOldArr = obj;
            const tempNewArr = [];
            for (let i in tempOldArr) {
                tempNewArr[i] = Utility.deepClone(tempOldArr[i])
            }
            return tempNewArr;
        }
        if (typeof obj === "object" && !!obj) {
            const tempNewObj = {};
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    tempNewObj[key] = Utility.deepClone(obj[key])
                }
            }
            return tempNewObj;
        }

        return obj;
    }

    static basicConvertSetToArray(setToConvert) {
        if (!(setToConvert instanceof Set)) {
            return setToConvert
        } else return Array.from(setToConvert);
    }

    static basicConvertArrayToSet(arrayToConvert) {
        if (!(Array.isArray(arrayToConvert))) {
            return arrayToConvert
        } else return new Set(arrayToConvert);
    }

    static basicConvertMapToObj(mapToConvert) {
        if (!(mapToConvert instanceof Map)) {
            return mapToConvert
        }
        return Object.fromEntries(mapToConvert)
    }

    static basicConvertObjToMap(objToConvert) {
        if (!objToConvert || typeof objToConvert !== "object" || objToConvert instanceof Map) {
            return objToConvert
        }
        return new Map(Object.entries(objToConvert))
    }

    static toggleFullScreen(fullscreenRefElement) {
        if (!fullscreenRefElement) {
            return;
        }
        if (isIOS) {
            if (!document.webkitFullscreenElement) {
                fullscreenRefElement.webkitRequestFullscreen();
            } else {
                document.webkitExitFullscreen().then();
            }
        } else {
            if (!document.fullscreenElement) {
                fullscreenRefElement.requestFullscreen().then();
            } else {
                document.exitFullscreen().then();
            }
        }
    }

    static validateUrl(str) {
        const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }


    static getMediaThumbnails(procedure) {
        let mediaThumbnail;
        if (procedure.MediaProcedureFile) {
            mediaThumbnail = Utility.renderFileThumbnail(procedure.MediaProcedureFile);
        }
        if (!mediaThumbnail && procedure.coverImg) {
            mediaThumbnail = <img
                className='procedure-card-image'
                src={procedure.coverImg}
                alt=""
                onError={event => {
                    if (event.target.className.includes('fallback')) {
                        return;
                    }
                    event.target.src = FallbackImage;
                    event.target.className += ' fallback'
                }}
            />;
        }
        if (procedure.ProcedureType === procedureTypeEnum.FUSION) {
            mediaThumbnail = <img
                className='procedure-card-image'
                src={logo}
                alt=""
            />;
        }
        if (procedure.ProcedureType === procedureTypeEnum.DESIGNER) {
            mediaThumbnail = <CompassIcon className='thumbnail-icon'/>;
        }
        if (procedure.ProcedureType === procedureTypeEnum.SITE_PREP) {
            mediaThumbnail = <HomeWorkIcon className='thumbnail-icon'/>;
        }
        if (procedure.ProcedureType === procedureTypeEnum.VIRTUAL_CLASS_ROOM) {
            mediaThumbnail = <HomeWorkIcon className='thumbnail-icon'/>;
        }
        if (!mediaThumbnail) {
            mediaThumbnail = <TimelineIcon className='thumbnail-icon'/>;
        }
        return mediaThumbnail;
    }

    static getChunks(file, isAws) {
        const chunkSize = isAws ? UPLOAD_CHUNK_SIZE_AWS : UPLOAD_CHUNK_SIZE;
        const totalChunks = Math.ceil(file.size / chunkSize);
        let chunkIndex = 0;
        const chunks = [];
        while (chunkIndex <= totalChunks) {
            const offset = chunkIndex * chunkSize;
            file.slice(offset, offset + chunkSize);
            const chunk = file.slice(offset, offset + chunkSize);
            if (!chunk.size) {
                break;
            }
            chunks.push(chunk);
            chunkIndex++;

        }
        return chunks;
    }

    static async shrinkFile(file) {
        const fileName = file.name;
        const fileType = sharedUtils.getTypeFromFileName(fileName);
        const fileExtension = fileName.split(".").pop().toLowerCase();
        if (fileType === fileTypeEnum.IMAGE && fileExtension !== 'gif') {
            file = await new Promise((resolve, reject) => new Compressor(file, {
                quality: 0.6,
                success: resolve,
                error: reject
            }));
        }
        return file;
    }

    static getThumbnail(fileUrl) {
        return new Promise((resolve, reject) => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d')
            const img = new Image();
            img.onload = function () {

                const {width, height} = this;
                const computedWidth = height < 200 ? width : (200 / height) * width;
                const computedHeight = height < 200 ? height : 200;
                canvas.width = computedWidth;
                canvas.height = computedHeight;
                ctx.drawImage(img, 0, 0, computedWidth, computedHeight);
                canvas.toBlob(blob => resolve(blob), 'image/jpeg');

            };

            img.onerror = reject;
            img.src = fileUrl;
        })
    }

    static async getVideoThumb(fileData) {
        try {

            const video = new Video(fileData);
            const thumbnails = await Promise.race([
                video.getThumbnails(),
                new Promise(resolve => {
                    setTimeout(() => {
                        console.error('getVideoThumb timed out');
                        resolve();
                    }, 10 * 1000);
                })
            ]);
            if (!thumbnails) {
                return null;
            }
            return URL.createObjectURL(thumbnails[0].blob);
        } catch (e) {
            console.error(e);
            return null;
        }
    }

    static async getBigImageData(file) {
        const fileName = file.name;
        const fileType = sharedUtils.getTypeFromFileName(fileName);
        const fileData = URL.createObjectURL(file);
        switch (fileType) {
            case fileTypeEnum.IMAGE:
                return fileData;

            case fileTypeEnum.VIDEO:
                return await Utility.getVideoThumb(fileData);

            case fileTypeEnum.PDF:
                const pdf = await getDocument(fileData).promise;
                if (!pdf.numPages) {
                    break;
                }
                const firstPage = await pdf.getPage(1);
                const pdfCanvas = document.createElement('canvas');
                const context = pdfCanvas.getContext('2d');

                const viewport = firstPage.getViewport({scale: 1});

                pdfCanvas.height = viewport.height;
                pdfCanvas.width = viewport.width;

                await firstPage.render({
                    canvasContext: context,
                    viewport: viewport
                }).promise;
                return pdfCanvas.toDataURL("image/jpeg");

            case fileTypeEnum.THREE_D:
            case fileTypeEnum.FUSION:
            case fileTypeEnum.FRONTLINE_WEB:
            case fileTypeEnum.FRONTLINE_ANDROID:
            case fileTypeEnum.FRONTLINE_IOS:
            case fileTypeEnum.FRONTLINE_WINDOWS:
            case fileTypeEnum.FRONTLINE_MAC:
            case fileTypeEnum.FRONTLINE_HOLOLENS:
            case fileTypeEnum.OTHER:
            default:
                return null;

        }
    }

    static async getThumbnailData(file) {
        const bigImageData = await Utility.getBigImageData(file);
        // noinspection UnnecessaryLocalVariableJS
        const thumbnailData = bigImageData ? await Utility.getThumbnail(bigImageData) : null;
        return thumbnailData;
    }

    static getSessionDurationString(session) {
        let durationMillis;
        if (!session.EndTimeStamp && !session.StartTimeStamp) {
            if (!session.Duration) {
                return '-';
            } else durationMillis = session.Duration;
        } else durationMillis = new Date(session.EndTimeStamp).valueOf() - new Date(session.StartTimeStamp).valueOf()
        if (durationMillis < 0) {
            return '-';
        }
        return sharedUtils.renderDisplayTime(durationMillis);
    }

    static sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    static sortByString(a, b, attributeName) {
        if (!a[attributeName]) {
            console.error('missing attribute ' + attributeName + ' in the first object', a);
            return 0;
        }
        return a[attributeName].localeCompare(b[attributeName]);
    }

    static getPathArray() {
        let pathStr = window.location.pathname;
        if (pathStr[pathStr.length - 1] === '/') {
            pathStr = pathStr.substring(0, pathStr.length - 1); // remove redundant last '/'
        }
        // noinspection UnnecessaryLocalVariableJS
        const pathArray = pathStr.split('/');
        return pathArray
    }

    static renderFullDate(date, dateLocale) { //TODO decide between this and getNormalDate
        if (!date) {
            return "-"
        }
        return new Date(date).toLocaleDateString(dateLocale || 'en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        })
    }

    static renderDate_DDMMYYY(dateStr) {
        if (!dateStr) {
            return '-';
        }
        const date = new Date(dateStr);
        const dayNumber = date.getDate();
        const monthNumber = date.getMonth() + 1;

        const day = dayNumber < 10 ? '0' + dayNumber : dayNumber;
        const month = monthNumber < 10 ? '0' + monthNumber : monthNumber;
        const year = date.getFullYear();
        return `${day}.${month}.${year}`
    }

    static renderDateTime_DDMMYYYY_HHMM(dateStr) {

        if (!dateStr) {
            return '-';
        }
        const date = new Date(dateStr);
        return `${Utility.renderDate_DDMMYYY(dateStr)} ${Utility.renderTime_HHMM(date)}`;
    }

    static renderTime_HHMM(date) {
        const hoursNumber = date.getHours();
        const minutesStr = date.getMinutes();

        const hours = hoursNumber < 10 ? '0' + hoursNumber : hoursNumber;
        const minutes = minutesStr < 10 ? '0' + minutesStr : minutesStr;

        return `${hours}:${minutes}`;
    }

    static renderFullDateTime(dateStr, dateLocale) {
        if (!dateStr) {
            return "-"
        }
        return new Date(dateStr).toLocaleString(dateLocale || 'en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        })
    }
    static renderFileNameDate(date) {
        const dateStr = Utility.renderDateTime_DDMMYYYY_HHMM(date);
        return dateStr.split(/[\s.:]/).join("_");
    }

    static addFakeCardsForAlignment(list, cardStyle, className) {
        if (!list) {
            return;
        }

        const numOfFakeToAdd = 10;
        for (let i = 0; i < numOfFakeToAdd; i++) {
            list.push(<FakeCard key={className + '_' + i} cardStyle={cardStyle} className={className + ' fake'}/>)
        }
    }

    static verifyEmail = (email) => {
        // noinspection RegExpRedundantEscape
        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailRegex.test(email);
    };

    static uglyDisableFocusStealing = async (dialogElementId) => {
        const a = document.getElementById(dialogElementId);
        await Utility.sleep(2000); // waiting for material ui to finish otherwise it will set it back
        a.childNodes[2].removeAttribute('tabindex');
    }

    static async parseFiles(files, limit, onError) {
        if (!files.length) {
            return;
        }

        if (files.length > limit) {
            onError('too many files, please select maximum ' + limit);
            throw new Error('too many files');
        }
        const promises = [];
        for (const file of files) {
            const promise = new Promise(resolve => {
                const reader = new FileReader();
                reader.onload = (event) => {
                    resolve({
                        data: event.target.result,
                        file
                    })
                };
                reader.readAsDataURL(file);
            });
            promises.push(promise);
        }
        return Promise.all(promises);
    }

    static verifyAndMessagePassword(password, confirmPassword) {
        if (password.length < 8) {
            return {
                message: "Password needs to have 8 or more characters.",
                success: false,
            };
        } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>])/.test(password)) {
            return {
                message: "Password needs to at least 1 capital letter, 1 small letter, 1 number and 1 special character.",
                success: false,
            };
        } else if (password !== confirmPassword) {
            return {
                message: "Confirm password does not match password.",
                success: false,
            };
        }
        return {
            success: true
        };
    }

    static getBaseUrl() {
        let {protocol, host} = window.location;
        // noinspection UnnecessaryLocalVariableJS
        const baseUrl = protocol + "//" + host;
        return baseUrl;

    }

    static getWebglBaseUrl() {
        // noinspection UnnecessaryLocalVariableJS
        const baseUrl =  window.location.origin;
        return baseUrl;
    }

    static getInitials(firstName, lastName) {
        let initials = firstName ? firstName[0] : "";
        initials += lastName ? lastName[0].slice(-1) : "";
        initials = initials.toUpperCase();
        return initials;
    }

    static async fetchFileAsBase64(url) {
        const response = await fetch(url);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    static async readDataFromUrl(url) {
        return new Promise(resolve => {

            const img = new Image();
            img.setAttribute('crossOrigin', 'anonymous');

            img.onload = async () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);

                const dataURL = canvas.toDataURL("image/png");
                resolve(dataURL);
            };

            img.src = url;
        })
    }

    static async getImageSize(url) {
        return new Promise(resolve => {
            const img = new Image();
            img.onload = async () => {
                const width = img.width;
                const height = img.height;
                resolve({width, height})
            }
            img.src = url;
        })
    }

    static overrideProcedureByVersion(procedure, procedureVersion) {
        if (!procedure) {
            return null;
        }

        procedure.CurrentVersion = procedureVersion.Version;
        procedure.ProcedureName = procedureVersion.ProcedureName;
        procedure.ProcedureTags = procedureVersion.ProcedureTags;
        procedure.PreRequiredProcedure = procedureVersion.PreRequiredProcedure;
        procedure.RequiredTools = procedureVersion.RequiredTools;
        procedure.RequiredExperience = procedureVersion.RequiredExperience;
        procedure.NestedNodes = procedureVersion.NestedNodes;
        procedure.PreRequiredProcedures = procedureVersion.PreRequiredProcedures;
        procedure.ProcedureDescription = procedureVersion.ProcedureDescription;
        procedure.coverImg = procedureVersion.coverImg;
        procedure.MediaProcedureFile = procedureVersion.MediaProcedureFile;
        procedure.ThreeDFilesAndroid = procedureVersion.ThreeDFilesAndroid;
        procedure.ThreeDFilesHololens = procedureVersion.ThreeDFilesHololens;
        procedure.ThreeDFilesIOs = procedureVersion.ThreeDFilesIOs;
        procedure.ThreeDFilesWebgl = procedureVersion.ThreeDFilesWebgl;
        procedure.ThreeDFilesWin = procedureVersion.ThreeDFilesWin;
        procedure.ThreeDFilesOsx = procedureVersion.ThreeDFilesOsx;
    }

    static buildUrl(baseRule, urlParams) {
        if (!baseRule) {
            return '';
        }

        for (const replaceFrom in urlParams) {
            if (!urlParams.hasOwnProperty(replaceFrom)) {
                continue;
            }

            const replaceTo = urlParams[replaceFrom];
            baseRule = baseRule.replace(`:${replaceFrom}`, replaceTo);
        }
        return baseRule;
    }

    static renderProcedureIconByType = procedureType => {
        switch (procedureType) {
            case procedureTypeEnum.REGULAR:
                return <TimelineIcon className="procedure-icon"/>;
            case procedureTypeEnum.MEDIA:
                return <TheatersIcon className="procedure-icon"/>;
            case procedureTypeEnum.THREE_D:
                return <LayersOutlinedIcon className="procedure-icon"/>;
            case procedureTypeEnum.FUSION:
                return <ThreeDIcon className="procedure-icon"/>;
            case procedureTypeEnum.SITE_PREP:
                return <SitePrepIcon className="procedure-icon"/>;
            case procedureTypeEnum.VIRTUAL_CLASS_ROOM:
                return <HomeWorkIcon className="procedure-icon"/>;
            default:
                return
        }
    }

    static renderFileThumbnail(file) {
        const thumbAddress = file.ThumbnailFileAddress || file.FileId;
        let threeDIcon;
        switch (file.FileType) {
            case fileTypeEnum.IMAGE:
                return (
                    <img
                        src={thumbAddress}
                        alt=''
                        onError={event => {
                            if (event.target.className.includes('fallback')) {
                                return;
                            }
                            event.target.src = FallbackImage;
                            event.target.className += ' fallback'
                        }}
                    />
                );
            case fileTypeEnum.VIDEO:
                return (
                    <img
                        src={thumbAddress}
                        alt=''
                        onError={event => {
                            if (event.target.className.includes('fallback')) {
                                return;
                            }
                            event.target.src = FallbackMovie;
                            event.target.className += ' fallback'
                        }}
                    />
                );
            case fileTypeEnum.PDF:
                return (
                    <img
                        src={thumbAddress}
                        alt=''
                        onError={event => {
                            if (event.target.className.includes('fallback')) {
                                return;
                            }
                            event.target.src = FallbackPdf;
                            event.target.className += ' fallback'
                        }}
                    />
                );
            case fileTypeEnum.FRONTLINE_DESIGNER:
                return (
                    <CompassIcon className='thumbnail-icon'/>
                );
            case fileTypeEnum.THREE_D:
                return (
                    <LayersOutlinedIcon className='thumbnail-icon'/>
                );
            case fileTypeEnum.FUSION:
                return (
                    <WhatshotIcon className='thumbnail-icon'/>
                );
            case fileTypeEnum.FRONTLINE_WEB:
                threeDIcon = webglIcon;
                break;
            case fileTypeEnum.FRONTLINE_ANDROID:
                threeDIcon = androidIcon;
                break;
            case fileTypeEnum.FRONTLINE_HOLOLENS:
                threeDIcon = holoLensIcon;
                break;
            case fileTypeEnum.FRONTLINE_IOS:
                threeDIcon = iosIcon;
                break;
            case fileTypeEnum.FRONTLINE_WINDOWS:
                threeDIcon = windowsIcon;
                break;
            case fileTypeEnum.FRONTLINE_MAC:
                threeDIcon = macIcon;
                break;
            default:
                return null;
        }
        return (
            <img
                src={threeDIcon}
                alt=''
                className='thumbnail-icon frontline3d'
            />
        );

    }

    static renderFilePreview(file, translateFunc, closeModal = () => {
    }) {
        if (!file || !file.FileType) {
            return <></>;
        }
        switch (file.FileType) {
            case fileTypeEnum.IMAGE:
                return <ResizableImage id={file.FileId} closeModal={closeModal}/>;
            case fileTypeEnum.VIDEO:
            case fileTypeEnum.MP4:
                return <DisplayVideo id={file.FileId} closeModal={closeModal}/>;
            case fileTypeEnum.PDF:
                return <DisplayPdf id={file.FileId} closeModal={closeModal}/>;
                case fileTypeEnum.DOCX:
                    return <DisplayDocx id={file.FileId} closeModal={closeModal}/>;
            default:
                return <Paper className='empty-file-preview'>
                    {translateFunc('cannotDisplayFile')}:<br/>
                    <strong>{file.FileName}.{file.FileExtension}</strong><br/>
                    {translateFunc('filesWithExtension')}&nbsp;
                    <strong>.{file.FileExtension}</strong>&nbsp;{translateFunc('areNotSupported', true)}.
                </Paper>;
        }
    }

    static unityColorToHex(colorObj) {
        if (colorObj) {
            const {r, g, b, a} = colorObj;
            const red = Math.round(r * 255).toString(16).padStart(2, '0');
            const green = Math.round(g * 255).toString(16).padStart(2, '0');
            const blue = Math.round(b * 255).toString(16).padStart(2, '0');
            const alpha = Math.round(a * 255).toString(16).padStart(2, '0');
            return `#${red}${green}${blue}${alpha}`;
        } else return null;
    }

    static mapNumberToFontName(number) {
        switch (number) {
            case fontsEnum.DARK:
                return "DarkColor";
            case fontsEnum.BRIGHT:
                return "BrightColor";
            case fontsEnum.DISABLED:
                return "DisabledColor";
            case fontsEnum.LINK:
                return "LinkColor";
            case fontsEnum.LEAVE_DELETE_NEW:
                return "LeaveDeleteNew";
            default:
                return 'DarkColor';
        }
    }

    static roundRectCorners(ctx, x, y, width, height, radius = 5, percentGap = 0.75, fill, stroke = true) {
        if (typeof radius === 'number') {
            radius = {tl: radius, tr: radius, br: radius, bl: radius};
        } else {
            const defaultRadius = {tl: 0, tr: 0, br: 0, bl: 0};
            for (let side in defaultRadius) {
                radius[side] = radius[side] || defaultRadius[side];
            }
        }
        const widthGap = width * percentGap;
        const heightGap = height * percentGap;
        ctx.beginPath();
        ctx.moveTo(x + radius.tl, y);
        ctx.lineTo(x + (width - widthGap) / 2, y);
        ctx.moveTo(x + (width + widthGap) / 2, y);
        ctx.lineTo(x + width - radius.tr, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
        ctx.lineTo(x + width, y + (height - heightGap) / 2);
        ctx.moveTo(x + width, y + (height + heightGap) / 2);
        ctx.lineTo(x + width, y + height - radius.br);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
        ctx.lineTo(x + (width + widthGap) / 2, y + height);
        ctx.moveTo(x + (width - widthGap) / 2, y + height);
        ctx.lineTo(x + radius.bl, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
        ctx.lineTo(x, y + (height + heightGap) / 2);
        ctx.moveTo(x, y + (height - heightGap) / 2);
        ctx.lineTo(x, y + radius.tl);
        ctx.quadraticCurveTo(x, y, x + radius.tl, y);
        if (fill) {
            ctx.fill();
        }
        if (stroke) {
            ctx.stroke();
        }
    }

    static removeHtmlTags(str) {
        if (!str || typeof str !== 'string') {
            return "";
        }
        const allLetters = str.replace(/<\/?[^>]+(>|$)/g, "").split("");
        allLetters.forEach(letter => String.fromCharCode(parseInt(letter, 16)));
        const joined = allLetters.join("");
        return Utility.removeHtmlSpecialChars(joined);
    }

    static getFullDomain(newDomain, previousDomain) {
        const {host} = window.location;
        return host.replace(`${previousDomain}.`, `${newDomain}.`);
    }

    static openProcedurePreview(procedureId, task, workspace) {
        if (task) {
            Cookies.set(GeneralStore.TASK_REF_COOKIE_NAME, task.TaskDataIdentifier);
        }
        const urlParams = {
            db: workspace,
            procedureId: procedureId
        }

        const procedureLink = Utility.buildUrl(routes.VIEWER, urlParams);
        window.open(procedureLink);
    }

    static async downloadApp(getLatestDirectly = false) {
        if (!getLatestDirectly) {
            if (Utility.isTablet() || Utility.isMobile()) {
                if (isIOS) {
                    window.location.href = Settings.appStoreLink;
                }
                if (Utility.isAndroid()) {
                    window.location.href = Settings.playStoreLink;
                }
                return;
            }
            if (isWindows && Settings.windowsStoreLink && !generalStore.workspaceIsHP) {
                window.location.href = Settings.windowsStoreLink;
                return;
            }
            if (isWindows && Settings.hpXrServicesLink && generalStore.workspaceIsHP) {
                window.location.href = Settings.hpXrServicesLink;
                return;
            }
        }
        try {
                const {url, fileName} = await GeneralRequester.getLatestFrontlineAR();
                const a = document.createElement('A');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
        } catch (e) {
            console.log(e);
        }
    }

    static buildSortMethod(sortAscending, firstProp, type = sortTypeEnum.NORMAL, secondProp) {   //type: 0 - normal, 1 - date, 2 - array, 3 - nested using secondProp
        const fixMissingProps = (listItemA, listItemB, propKey, altItem) => {
            let itemA = listItemA[propKey] || altItem;
            let itemB = listItemB[propKey] || altItem;
            if (typeof itemA !== typeof itemB) {
                itemA = String(itemA);
                itemB = String(itemB);
            }
            if (typeof itemA === 'string') {
                itemA = itemA.toLowerCase();
            }
            if (typeof itemB === 'string') {
                itemB = itemB.toLowerCase();
            }
            return {itemA, itemB}
        }

        switch (type) {
            case sortTypeEnum.NORMAL:
                return (listItemA, listItemB) => {
                    const {itemA, itemB} = fixMissingProps(listItemA, listItemB, firstProp, 0);
                    if (itemA < itemB) {
                        return sortAscending ? -1 : 1;
                    }
                    if (itemA > itemB) {
                        return sortAscending ? 1 : -1;
                    }
                    return 0;
                }
            case sortTypeEnum.DATE:
                return (listItemA, listItemB) => sortAscending
                    ? new Date(listItemA[firstProp] || 0) - new Date(listItemB[firstProp] || 0)
                    : new Date(listItemB[firstProp] || 0) - new Date(listItemA[firstProp] || 0);
            case sortTypeEnum.ARRAY:
                return (listItemA, listItemB) => {
                    const {itemA, itemB} = fixMissingProps(listItemA, listItemB, firstProp, []);
                    return sortAscending
                        ? itemA.length - itemB.length
                        : itemB.length - itemA.length
                }
            case sortTypeEnum.NESTED_SECOND_PROP:
                return (listItemA, listItemB) => {
                    const {
                        itemA: nestLevel1ItemA,
                        itemB: nestLevel1ItemB
                    } = fixMissingProps(listItemA, listItemB, firstProp, {});
                    const {itemA, itemB} = fixMissingProps(nestLevel1ItemA, nestLevel1ItemB, secondProp, "");
                    if (itemA < itemB) {
                        return sortAscending ? -1 : 1;
                    }
                    if (itemA > itemB) {
                        return sortAscending ? 1 : -1;
                    }
                    return 0;
                }
            default:
                return () => {
                };
        }
    }

    static removeHtmlSpecialChars(str) {
        if (!str) {
            return '';
        }

        const htmlSpecialChars = {
            nbsp: ' ',
            lt: '<',
            gt: '>',
            amp: '&',
            quot: '"',
            apos: "'",
            cent: '¢',
            pound: '£',
            yen: '¥',
            euro: '€',
            copy: '©',
            reg: '®',
            Agrave: "À",
            agrave: "à",
            Acirc: "Â",
            acirc: "â",
            AElig: "Æ",
            aelig: "æ",
            Ccedil: "Ç",
            ccedil: "ç",
            Egrave: "È",
            egrave: "è",
            Eacute: "É",
            eacute: "é",
            Ecirc: "Ê",
            ecirc: "ê",
            Euml: "Ë",
            euml: "ë",
            Icirc: "Î",
            icirc: "î",
            Iuml: "Ï",
            iuml: "ï",
            Ocirc: "Ô",
            ocirc: "ô",
            OElig: "Œ",
            oelig: "œ",
            Ugrave: "Ù",
            ugrave: "ù",
            Ucirc: "Û",
            ucirc: "û",
            Uuml: "Ü",
            uuml: "ü",
            szlig: 'ß',
            auml: "ä",
            Auml: "Ä",
            ouml: "ö",
            Ouml: "Ö",
            Aacute: "Á",
            aacute: "á",
            Iacute: "Í",
            iacute: "í",
            Ntilde: "Ñ",
            ntilde: "ñ",
            Oacute: "Ó",
            oacute: "ó",
            Uacute: "Ú",
            uacute: "ú",
            laquo: "«",
            raquo: "»",
            iquest: "¿",
            iexcl: "¡",
        }

        for (const [key, value] of Object.entries(htmlSpecialChars)) {
            str = str.split(`&${key};`).join(value)
        }
        return str;
    }


    static dashToCamel(string) {
        return string.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
    }

    static getUserFullName(user) {
        if (!user) {
            return ""
        }
        let fullName = "";
        fullName += user.Name || "";
        fullName += !!user.Name && !!user.LastName ? " " : "";
        fullName += user.LastName || "";
        return fullName;
        // return `${user.Name || ""}${user.LastName ? ` ${user.LastName}` : ""}`
    }

    static getBigNumberString(number) {
        const numArr = String(number).split('');
        const len = numArr.length;
        const newNumArr = [];
        for (let i = 0; i < Math.ceil(len / 3); i++) {
            newNumArr.unshift(numArr.splice(-3));
            newNumArr.unshift(",");
        }
        return newNumArr.flat().slice(1).join('')
    }

    static getLanguageNameFromProp = prop => {
        if (!prop || prop.length === 0) {
            return ""
        }

        const languageArr = prop.split("_");
        const languageName = strToCapital(languageArr[0].toLowerCase());
        return `${languageName}${languageArr.length > 1 ? ` (${getAltLangName(languageArr[1])})` : ""}`
    }

    static getLanguageComponents = prop => {
        return {
            langKey: languageEnum[prop],
            countryKey: languageEnum[prop]?.split("-").pop(),
            languageName: Utility.getLanguageNameFromProp(prop)
        }
    }

    static getLanguageName = langKey => {
        const props = Object.keys(languageEnum);
        const langProp = props.find(prop => languageEnum[prop] === langKey);
        return Utility.getLanguageNameFromProp(langProp);
    }

    static renderLanguageMenuOption = (language, i, currentDefault, showName = true, showDefault = true, extraParams = {}) => {
        const {langKey, countryKey, languageName} = Utility.getLanguageComponents(language);
        const {
            showSwitch,
            isAddLanguageFlow,
            openPopover,
            setOpenPopover,
            anchorElMorePopover,
            setAnchorElMorePopover,
            setShowConfirmDeletePopup,
            handleChangeDefaultLanguage,
            selectedLanguagesToAdd,
            setSelectedLanguagesToAdd,
            setLanguageToDelete,
            isEditFlow,
            isAccountSettings,
            sendProcedureToAi = () => {},
        } = extraParams;
        const visible = procedureStore.languagesVisibility?.hasOwnProperty(langKey) ? procedureStore.languagesVisibility?.[langKey] : true;
        const ableToSeeNotVisible = isEditFlow || procedureStore.languagesVisibility?.[langKey] || currentDefault === langKey || modalStore.modalData.fromEditor || isAccountSettings;
        const GradientIcon = () => (
            <svg width="0" height="0">
                <defs>
                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style={{stopColor: '#6A00F4', stopOpacity: 1}}/>
                        <stop offset="100%" style={{stopColor: '#044cfa', stopOpacity: 1}}/>
                    </linearGradient>
                </defs>
            </svg>
        );
        return anchorElMorePopover || isAddLanguageFlow ? <div key={langKey + i}
                                                               className={`language-select-item${showName ? " condensed" : ""} ${!isAddLanguageFlow && i !== 0 ? 'edit-flow-elements' : 'edit-flow-first-element'}`}>
                <>
                    <img className="language-flag" src={getCountryFlag(countryKey)} alt={countryKey}/>
                    <span>{languageName}{showDefault && currentDefault && currentDefault === langKey ? " - " + generalStore.translate("default", true) : ""}</span>
                </>
                <ConditionalComponent if={showSwitch && currentDefault !== langKey}>
                   <span className="visible-and-more-icon">
                       <span>{generalStore.translate("visible")}</span>
                <FrontlineCheckbox
                    isChecked={visible}
                    onChange={async () => {
                        generalStore.isLoaderOpen = true;
                        await procedureStore.changeLanguageVisibility(langKey);
                        generalStore.isLoaderOpen = false;
                    }}/>
                      <MoreHorizIcon className='more-icon'
                                     onClick={(e) => handleMoreClick(e, !!openPopover, setOpenPopover, langKey, anchorElMorePopover, setAnchorElMorePopover)}
                                     fontSize='large'/>
                   </span>
                    <Popover anchorEl={anchorElMorePopover?.[langKey]}
                             anchorOrigin={{
                                 vertical: 'bottom',
                                 horizontal: 'center',
                             }}
                             transformOrigin={{
                                 vertical: 'top',
                                 horizontal: 'center',
                             }}
                             open={!!openPopover?.[langKey]}
                             onClose={(e) => handleMoreClick(e, openPopover, setOpenPopover, langKey, anchorElMorePopover, setAnchorElMorePopover)}
                    >
                        <div className='language-more-menu'>
                            <div className='change-default'
                                 onClick={() => handleChangeDefaultLanguage(langKey)}>{generalStore.translate('makeDefault')}
                            </div>
                            <ConditionalComponent if={generalStore.isTranslationAiEnabled && !!sendProcedureToAi}>
                                <div className='change-default'
                                     onClick={() => sendProcedureToAi(langKey)}>
                                    {'Translate with AI'}
                                    <GradientIcon/>
                                    <AutoAwesomeIcon
                                        style={{
                                            fill: "url(#gradient1)",
                                            fontSize: "22px",
                                            marginLeft: "5px"
                                        }}
                                    />
                                </div>
                                <div className="divider"/>
                            </ConditionalComponent>
                            <div className='delete-button'>
                                <Button onClick={() => {
                                    setLanguageToDelete(langKey);
                                    setShowConfirmDeletePopup(true)}
                                } className='delete-language'>
                                    <DeleteOutlineIcon className='delete-language'/>
                                    <span className='delete-language'>
                                        {generalStore.translate('delete')}
                                    </span>
                                </Button>
                            </div>
                        </div>
                    </Popover>
                </ConditionalComponent>
                <ConditionalComponent if={showSwitch && currentDefault === langKey}>
                        <span className='default-language-text'>
                            {generalStore.translate('Default')}
                        </span>
                </ConditionalComponent>
                <ConditionalComponent if={isAddLanguageFlow}>
                    <span className='add-language-checkbox-container'><FrontlineCheckbox
                        onChange={() => {
                            if (selectedLanguagesToAdd?.includes(langKey)) {
                                setSelectedLanguagesToAdd(selectedLanguagesToAdd.filter((selectedLang) => selectedLang !== langKey));
                            } else {
                                setSelectedLanguagesToAdd([...selectedLanguagesToAdd, langKey]);
                            }
                        }}
                        isChecked={selectedLanguagesToAdd?.includes(langKey)}/></span>
                </ConditionalComponent>
            </div>
            : (ableToSeeNotVisible ? <MenuItem key={langKey + i} value={langKey}
                                               className={`language-select-item${showName ? " condensed" : ""}`}>
                {showName
                    ? <>
                        <img className="language-flag" src={getCountryFlag(countryKey)} alt={countryKey}/>
                        <span>{languageName}{showDefault && currentDefault && currentDefault === langKey ? " - " + generalStore.translate("default", true) : ""}</span>
                    </>
                    : <Tooltip title={languageName}>
                        <>
                            <img className="language-flag" src={getCountryFlag(countryKey)} alt={countryKey}/>
                            <span>{langKey}</span>
                        </>
                    </Tooltip>
                }
            </MenuItem> : null)
    }

    static setItemInMap = (newItem, itemId, currentMap, setMap, forceRerender = false) => {
        const tempMap = new Map(currentMap);
        if (forceRerender) {
            tempMap.set(itemId, {});
            setMap(tempMap);
        }
        tempMap.set(itemId, newItem);
        setMap(tempMap);
    }

    static deleteItemInMap = (itemId, currentMap, setMap, forceRerender = false) => {
        const tempMap = new Map(currentMap);
        if (forceRerender) {
            tempMap.set(itemId, {});
            setMap(tempMap);
        }
        tempMap.delete(itemId);
        setMap(tempMap);
    }

    static openInteractionEditor = async (db, procedureId, interactionId = null) => {
        const serverAddressArr = Settings.frontlineArServer.split("://");
        let host = window.location.host;
        if (host.includes("localhost")) {
            host = db + "." + serverAddressArr[1]
        }
        const serverAddress = serverAddressArr[0] + "://" + host;

        let deepPath = this.buildUrl(routes.EDIT_INTERACTIONS, {db, procedureId});

        const tempToken = await GeneralRequester.getTempToken();
        deepPath += '?&t=' + tempToken;
        if (!!interactionId) {
            deepPath += '&interactionStepId=' + interactionId
        }

        const finalDeepLink = `procedureio://frontline-ar?d=${serverAddress}/${encodeURIComponent(deepPath)}`

        console.log(finalDeepLink);
        window.location.href = finalDeepLink;
    }

    static escapeWorkbookName(procedureNameInSheet) {
        const workbookIllegalChars = [':', '[', ']', '?', '*', '\\', '/'];
        workbookIllegalChars.forEach(illegalChar => {
            procedureNameInSheet = procedureNameInSheet.split(illegalChar).join(' ');
        });
        return procedureNameInSheet;
    }

    static openPartsCatalog = async (db, procedureId) => {
        const serverAddressArr = Settings.frontlineArServer.split("://");
        let host = window.location.host;
        if (host.includes("localhost")) {
            host = db + "." + serverAddressArr[1]
        }
        const serverAddress = serverAddressArr[0] + "://" + host;

        let deepPath = this.buildUrl(routes.PARTS_CATALOG, {db, procedureId});
        const tempToken = await GeneralRequester.getTempToken();
        deepPath += '?&t=' + tempToken;
        console.log(Cookies.get(Settings.tokenCookieName))

        const finalDeepLink = `procedureio://frontline-ar?d=${serverAddress}/${encodeURIComponent(deepPath)}`

        console.log(finalDeepLink);
        window.location.href = finalDeepLink;
    }

    static getNodeTypeKey = nodeType => {
        switch (Number(nodeType)) {
            case procedureNodeTypeEnum.CONNECTION_POINT:
                return editorNodeTypeEnum.CONNECTION_POINT
            case procedureNodeTypeEnum.START:
                return editorNodeTypeEnum.START
            case procedureNodeTypeEnum.QUESTION:
                return editorNodeTypeEnum.QUESTION
            case procedureNodeTypeEnum.MULTI:
                return editorNodeTypeEnum.MULTI
            case procedureNodeTypeEnum.WARNING:
                return editorNodeTypeEnum.WARNING
            case procedureNodeTypeEnum.WARNING_POPUP:
                return editorNodeTypeEnum.WARNING_POPUP
            case procedureNodeTypeEnum.Input:
                return editorNodeTypeEnum.INPUT
            case procedureNodeTypeEnum.INNER_PROCEDURE:
                return editorNodeTypeEnum.INNER_PROCEDURE
            case procedureNodeTypeEnum.PLATFORM_SWITCH:
                return editorNodeTypeEnum.MULTI
            case procedureNodeTypeEnum.OBJECT_DETECTION:
                return editorNodeTypeEnum.OBJECT_DETECTION
            default:
                return editorNodeTypeEnum.STEP
        }
    }

    static getFlippedCanvasContext(canvas) {
        const ctx = canvas.current.getContext('2d');
        ctx.setTransform(-1, 0, 0, 1, canvas.current.width, 0);
        return ctx;
    }

    static getProcedureTypeIcon(procedure) {
        const {
            FUSION,
            VIRTUAL_ROOM,
            SITE_PREP,
            VIRTUAL_CLASS_ROOM,
            PATIENT,
            LINK,
            THREE_D,
            MEDIA,
            DESIGNER
        } = procedureTypeEnum;
        switch (procedure.ProcedureType) {
            case FUSION:
                return <ThreeDIcon className='thumbnail-icon'/>;

            case MEDIA:
                return <TheatersIcon className='thumbnail-icon'/>;

            case VIRTUAL_ROOM:
                return <WeekendIcon className='thumbnail-icon'/>;

            case THREE_D:
                return <LayersOutlinedIcon className='thumbnail-icon'/>;

            case SITE_PREP:
                return <SitePrepIcon className='thumbnail-icon'/>;

            case VIRTUAL_CLASS_ROOM:
                return <HomeWorkIcon className='thumbnail-icon'/>;

            case PATIENT:
                return <PersonIcon className='thumbnail-icon'/>;

            case LINK:
                return <LinkIcon className='thumbnail-icon'/>;

            case DESIGNER:
                return <CompassIcon className='thumbnail-icon'/>;

            default:
                return <TimelineIcon className='thumbnail-icon'/>;
        }
    }

    static getObjectsEqual(obj1, obj2) {
        if (obj1.data) {
            if (!obj2.data) {
                return false
            }
            obj1.data.connectionLines = this.basicConvertMapToObj(obj1.data.connectionLines);
            obj2.data.connectionLines = this.basicConvertMapToObj(obj2.data.connectionLines);
            obj1.data.connectionPoints = this.basicConvertMapToObj(obj1.data.connectionPoints);
            obj2.data.connectionPoints = this.basicConvertMapToObj(obj2.data.connectionPoints);
            obj1.data.handles = this.basicConvertSetToArray(obj1.data.handles);
            obj2.data.handles = this.basicConvertSetToArray(obj2.data.handles);
            obj1.data.files = this.basicConvertMapToObj(obj1.data.files);
            obj2.data.files = this.basicConvertMapToObj(obj2.data.files);
            if (!!obj1.data?.interactions) {
                const updatedInteractions = [];
                obj1.data.interactions.forEach(interaction => {
                    interaction.interactionParams = Utility.basicConvertMapToObj(interaction.interactionParams);
                    updatedInteractions.push(interaction);
                });
                obj1.data.interactions = updatedInteractions;
            }
            if (!!obj2.data?.interactions) {
                const updatedInteractions = [];
                obj2.data.interactions.forEach(interaction => {
                    interaction.interactionParams = Utility.basicConvertMapToObj(interaction.interactionParams);
                    updatedInteractions.push(interaction);
                });
                obj2.data.interactions = updatedInteractions;
            }
        }
        return JSON.stringify(obj1) === JSON.stringify(obj2);
    }

    static debounce(func, timeout = 300) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    }

    static openHelpdesk() {
        window.open(`https://${sharedUtils.HELPDESK_DOMAIN}.frontline.io`);
    }

    static async downloadExcel(worksheets, fileName) {
        const Workbook = await importWorkbookAsync();
        const workbook = new Workbook();

        worksheets.forEach(worksheet => {
            const ws = workbook.addWorksheet(worksheet.name);
            ws.columns = worksheet.columns;
            worksheet.rows.forEach(row => ws.addRow(row).commit());
        });

        const bufferedData = await workbook.xlsx.writeBuffer();
        let blob = new Blob([bufferedData], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        FileSaver.saveAs(blob, fileName);
    }

    static getValueEvenIf0(value, fallbackValue) {
        if (value === 0 || value === '0' || !!value) {
            return value;
        } else {
            return fallbackValue;
        }
    }
    static ifArrayEquals(arr1, arr2) {
        if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
        if (arr1.length !== arr2.length) return false;

        const set1 = new Set(arr1);
        const set2 = new Set(arr2);

        if (set1.size !== set2.size) return false;

        for (const item of set1) {
            if (!set2.has(item)) return false;
        }

        return true;
    }

    static areFlatRolesEqual(obj1, obj2) {

        const roleKeys = Object.keys(obj1).filter(k => k.startsWith("Pending_Roles_"));

        for (let key of roleKeys) {
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }

        return true;
    }

    static buildRoles(trainingArray, contentArray) {
        const allTrainingRoles = Object.keys(trainingAndFieldRoleEnum);
        const allContentRoles = Object.keys(contentCreatingRoleEnum);
        const result = {};
        if (trainingArray.length > 0) {
            allTrainingRoles.forEach(role => {
                const key = `Pending_Roles_TrainingAndFieldRole_${role}`;
                result[key] = trainingArray.includes(trainingAndFieldRoleEnum[role]);
            });
        }
        if (contentArray.length > 0) {
            allContentRoles.forEach(role => {
                const key = `Pending_Roles_ContentCreationRole_${role}`;
                result[key] = contentArray.includes(contentCreatingRoleEnum[role]);
            });
        }

        return result;
    }

    static extractRoles(doc) {
        const trainingRoles = [];
        const contentRoles = [];

        const trainingPrefix = "Pending_Roles_TrainingAndFieldRole_";
        const contentPrefix = "Pending_Roles_ContentCreationRole_";

        for (const key in doc) {
            if (key.startsWith(trainingPrefix) && doc[key] === true) {
                const fieldName = key.slice(trainingPrefix.length);
                trainingRoles.push(trainingAndFieldRoleEnum[fieldName]);
            } else if (key.startsWith(contentPrefix) && doc[key] === true) {
                const fieldName = key.slice(contentPrefix.length);
                contentRoles.push(contentCreatingRoleEnum[fieldName]);
            }
        }

        return {trainingRoles, contentRoles};
    }

}
